
$('.carousel-inner').slick({
    infinite: true,
    adaptiveHeight: true,
    arrows: true,
    lazyLoad: 'ondemand',
    nextArrow: '<button type="button" class="slick-next icon-arrow-right"></button>',
    prevArrow: '<button type="button" class="slick-prev icon-arrow-right"></button>',
    asNavFor: '.carousel-inner-thumb'
});

var prev = $('.carousel').data('prev');
var next = $('.carousel').data('next');

$('.carousel-inner-thumb').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.carousel-inner',
    prevArrow: '<button type="button" class="slick-prev">' + prev + '</button>',
    nextArrow: '<button type="button" class="slick-next">' + next + '</button>',
    centerMode: true,
    vertical: true,
    focusOnSelect: true
});
setTimeout(function () {
    $('.product-recommendation-grid').slick({
        infinite: true,
        adaptiveHeight: true,
        arrows: true,
        lazyLoad: 'ondemand',
        nextArrow: '<button type="button" class="slick-next icon-arrow-right"></button>',
        prevArrow: '<button type="button" class="slick-prev icon-arrow-right"></button>',
        dots: false,
        speed: 300,
        slidesToShow: 3,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 7000,
        responsive: [
            {
                breakpoint: 1026,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 778,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.recommendations').removeClass('d-none');
}, 2000);
